import { clsx } from "clsx";
import { ReactElement } from "react";

import { Button } from "../catalyst/Button";
import { AIAssistantChatSize } from "./AIAssistantChat";

type Props = {
  error: string;
  isLoading?: boolean;
  onRetry: () => void;
  size?: AIAssistantChatSize;
};

export const ErrorRetryButton = ({
  error,
  isLoading,
  onRetry,
  size,
}: Props): null | ReactElement => {
  if (!error) return null;
  return (
    <div className="space-y-4 rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-800 dark:bg-red-900/20">
      <div className="text-sm font-medium text-red-700 dark:text-red-400">
        Connection error
      </div>
      <p className="text-sm text-red-600 dark:text-red-300">{error}</p>
      <Button
        className={clsx({ "w-full": size === "small" })}
        color="emerald"
        disabled={isLoading}
        onClick={onRetry}
      >
        {isLoading ? "Connecting…" : "Try again"}
      </Button>
    </div>
  );
};
